// Next
import { Link } from 'react-router-dom'

// Mantine
import { Anchor, Progress, RingProgress } from '@mantine/core'

// Custom UI components
import Badge from '@/components/ui/Badge'

// Production order statuses
import statuses from '@/lib/productionOrderStatuses'

// Dayjs
import dayjs from 'dayjs'

export default function ProductionOrderSmallDisplay({
    production_order,
    isOutput = false,
}) {
    const status = statuses(production_order)

    const quantity_remaining = Math.max(
        0,
        production_order.quantity - production_order.quantity_completed
    )

    // Progress
    const progress =
        (production_order.quantity_completed / production_order.quantity) * 100

    const progress_control =
        (production_order.quantity_in_control / production_order.quantity) * 100

    // Verbose interval
    const verbose_interval = `Du ${dayjs(production_order.starting_at).format(
        'll'
    )} au ${dayjs(production_order.ending_at).format('ll')}`

    // Vocable
    const vocable = isOutput ? 'restants à utiliser' : 'restants à terminer'

    return (
        <Link
            className="flex justify-between items-center border p-2 rounded-xl hover:bg-gray-50"
            to={`/assembly/${production_order.id}`}
        >
            <div className="flex gap-3 items-center">
                <RingProgress
                    size={60}
                    thickness={30}
                    sections={[
                        {
                            value: progress,
                            color: 'green',
                            tooltip: `${production_order.quantity_completed} terminée(s)`,
                        },
                        {
                            value: progress_control,
                            color: 'orange',
                            tooltip: `${production_order.quantity_in_control} en contrôle`,
                        },
                    ]}
                />

                <div className="flex flex-col items-start">
                    <Anchor component="span">
                        A{production_order.id} -{' '}
                        {production_order?.component?.name} (
                        {production_order.quantity})
                    </Anchor>

                    <span className="text-gray-400 text-sm">
                        {verbose_interval}
                    </span>

                    <div className="flex items-center gap-2 text-sm mt-1">
                        <div className="flex gap-2 ">
                            {production_order.quantity_completed > 0 && (
                                <span className="text-green-500">
                                    {production_order.quantity_completed}{' '}
                                    terminés
                                </span>
                            )}

                            {production_order.quantity_in_control > 0 && (
                                <span className="text-orange-500">
                                    {production_order.quantity_in_control} en
                                    contrôle
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col items-end gap-3">
                <span className="text-sm text-gray-400">
                    {production_order.location.name}
                </span>

                <Badge color={status.badgeColor} size="sm">
                    {`${quantity_remaining} ${vocable}`}
                </Badge>
            </div>
        </Link>
    )
}
